import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";

export const BrandTextInput = ({
  formControl,
  field,
  label,
  inputComponent,
  isDisabled,
  slotProps,
  ...props
}) => {
  const resolvedSlotProps =
    slotProps ??
    (inputComponent ? { input: { inputComponent } } : undefined);

  return (
    <Controller
      name={field}
      control={formControl}
      defaultValue=""
      render={({ field, fieldState: { error } }) => {
        return (
          <TextField
            {...props}
            {...field}
            disabled={isDisabled}
            label={label}
            error={!!error}
            helperText={error?.message}
            slotProps={resolvedSlotProps}
          />
        );
      }}
    />
  );
};
